<template>   
      <div v-if="regimeType == 'oldregime' || regimeType == 'newregime'" class="main-container d-content">
    <div class="row fbp-summary-box">
       <div class="regime-Type">
        <p class="fbp-declaration-text">FBP Declaration</p>
        <p class="fbp-declaration-text">Selected Regime : {{ regimeTypeDisplay}}</p>
       </div>
      <div class="row amountDiv">
        <!-- <div class="col-2 amountColum">
          <div class="amountHeading">Name :</div>
          <div class="fbpAmount">{{formate.format(fbpAllocationDetails.special_allowance) }}</div>
        </div> -->
        <div class="col-2 amountColum">
          <div class="amountHeading">CTC :</div>
          <div class="fbpAmount">{{ formate.format(ctcAmount)}}</div>
        </div>
        <div class="col-2 amountColum">
          <div class="amountHeading">Effective Date :</div>
          <div class="fbpAmount">{{ effectiveDate}}</div>
        </div>
        <div class="col-2 amountColum">
          <div class="amountHeading">Monthly {{ specialAllowanceLabel }}</div>
          <div class="fbpAmount">{{ formate.format(monthltSpecialAllowance)}}</div>
        </div>
        <!-- <div class="col-2 amountColum">
          <div class="amountHeading">Employee Code :</div>
          <div class="fbpAmount">{{ formate.format(fbpAllocationDetails.unallocated_amount)}}</div>
        </div> -->
        <!-- <div class="col-2 amountColum">
          <div class="amountHeading">Date of Joining :</div>
          <div class="fbpAmount">{{ showJoiningDate}}</div>
        </div> -->
        <div class="col-2 amountColum">
          <div class="amountHeading">Pro-rated {{ specialAllowanceLabel }} :</div>
          <div class="fbpAmount">{{ formate.format(specialAllowance)}}</div>
        </div>
        <div class="col-2 amountColum">
          <div class="amountHeading">Balanced Monthly {{ specialAllowanceLabel }}</div>
          <div class="fbpAmount">{{ formate.format(monthltSpecialAllowanceDeclared)}}</div>
        </div>
        <div class="col-2 amountColum">
          <div class="amountHeading">{{ specialAllowanceLabel }} Paid till Date :</div>
          <div class="fbpAmount">{{ formate.format(this.fbpAllocationDetails instanceof Array ? this.fbpAllocationDetails[this.fbpAllocationDetails.length-1].spAllowancePaidTillDate:this.fbpAllocationDetails.spAllowancePaidTillDate)}}</div>
        </div>
        <!-- <div class="col-2 amountColum">
          <div class="amountHeading">FBP Plan balance</div>
          <div class="fbpAmount">{{ formate.format(fbpAllocationDetails.unAllocatedFbp)}}</div>
        </div> -->
      </div>
    </div>
    <toast-message
    v-show="toast"
              class="alert-msg"
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
    <div class="permission-alert-msg" v-show="showErrorMsg">
              Monthly declaration amount must be lesser than monthly eligibility
              value.
            </div>
    <div class="permission-alert-msg" v-show="showErrorMsgs">
              Negative values are not allowed.
            </div>
    <div class="tableList">
      <data-table class="tableClass" :columns="fbpColums" :tableData="fbpData" :showinrow="true" @editStart="false"
        :showedit="false" :showdelete="false" :showhistory="false">
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'salaryComponentLEName'">
            {{ slotprops.value.record.salaryComponentLEName }}
          </p>
          <p style="text-align:right;" v-if="slotprops.value.column.key == 'value'">
            {{ formateLess.format(slotprops.value.record[slotprops.value.column.key])}}
          </p>
          <p style="text-align:right;" v-if="slotprops.value.column.key == 'yearly_eligibility'">
            {{ formateLess.format(slotprops.value.record.yearly_eligibility)}}
          </p>
          <txt  v-if="slotprops.value.column.key == 'monthly_declaration_amount'" class="custom"
            v-model="slotprops.value.record[slotprops.value.column.key]" @change="
              (val) =>
                saveValues(
                  slotprops.value.record[slotprops.value.column.key],
                  slotprops.value.record,
                  'monthly_declaration_amount'
                )
            " @blur="saveValuesFecthing(slotprops.value.record)" />
          <p style="text-align:right;" v-if="slotprops.value.column.key == 'annual_declared_amount'">
            {{ formateLess.format(slotprops.value.record.annual_declared_amount)}}
          </p>
        </template>
      </data-table>
    </div>
    <pop-up-message
            v-if="showSuccessMsg"
            :message="successMessage"
            btnText="Back"
            @back="backFromPopUp()"
          />
          <pop-up-message
            v-if="config_error"
            :popupType = "'Warning'"
            :popupHeaderMessage="'Configuration error'"
            :message="errmsg_popup"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="primary" @click="goBack" />
        </btn-grp>
      </template>
    </pop-up-message>
    <pop-up-message
            v-if="regime_not_selected"
            :popupType = "'Warning'"
            :popupHeaderMessage="'Select Tax Regime'"
            :message="`Select tax regime before declaring FBP!`"
    >
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="primary" @click="goBack" />
        </btn-grp>
      </template>
    </pop-up-message>
    <footer>
      <bottom-action-container>
        <div v-if="le_id == 'dfba4011-0c5e-46cc-b4f4-99f5962f9ebe' || le_id == 'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0'" class="submitNote">
          <div class="note">
            <p>Note: </p>
          </div>
          <div class="noteContent">
            <p>1. Under the Old Tax Regime NPS Exemption is 10% of Basic+DA & under New Tax Regime NPS exemption is 14% of Basic+DA</p>
            <!-- <p>2. Other FBP components amount will be exempted only for Old Tax Regime</p> -->
          </div>

        </div>
        <template slot="end">
          <btn-grp class="form-button">
            <btn :disabled="showErrorMsg" text="Save as a Draft" type="secondary" @click="saveDraft" />
            <btn :disabled="showErrorMsg" text="Submit" type="primary" @click="goSubmit"/>
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "fbpDEclaration",
  data() {
    return {
      regimeType: false,
      regimeTypeDisplay :'New Regime',
      regime_not_selected:false,
      config_error:false,
      errmsg:'',
      errmsg_popup:'',
      toast: false,
      is_submitted: false,
      financial_year:'',
      formate: "",
      formateLess:"",
      fetchingBack:false,
      showErrorMsg: false,
      showErrorMsgs:false,
      successMessage:"",
      showSuccessMsg :false,
      fbpAllocationDetails: {},
      componentList:[],
      slabIdFetced:"",
      fetchedId:"",
      fbpColums: [
        {
          label: "FBP Components Name",
          key: "salaryComponentLEName",
        },
        {
          label: "Monthly Eligibility(₹)",
          key: "value",
          style:'text-align:right',
        },
        {
          label: "Yearly Eligibility(₹)",
          key: "yearly_eligibility",
          style:'text-align:right',
        },
        {
          label: "Monthly Declaration(₹)",
          key: "monthly_declaration_amount",  
        },
        {
          label: "Annual Declaration(₹)",
          key: "annual_declared_amount",
          style: 'text-align:right',
        },
      ],
      fbpData: [],
    };
  },
  mounted() {
    this.fetchAllData()
    this.fetchAll()
    this.showSuccessMsg = false;
  },
  activated(){
    this.fetchAllData()
    this.fetchAll()
    this.showSuccessMsg = false;
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),

    le_id() {
      return localStorage.getItem("le_id")
    },
    empId() {
      return localStorage.getItem("empId")
    },
    specialAllowanceLabel() {
      const pdaEntities = [
        'dfba4011-0c5e-46cc-b4f4-99f5962f9ebe',
        'ac40f8c0-8ccb-46c3-aa7c-7958dc8014f0'
      ];
      const hraEntities = [
        'eeddce5f-655a-4527-8cf1-a408f44fbad7',
        'b194b460-1197-4304-83e0-60eebe7fe956',
        'e72b1b01-d798-4afd-9b6e-88285d1bbaed'
      ];
      if (pdaEntities.includes(this.le_id)) return 'Professional Development Allowance';
      if (this.le_id === '98d4b7fe-9444-4f65-9d12-155eeffab56a') return 'Conveyance';
      if (hraEntities.includes(this.le_id)) return 'HRA';
      return 'Special Allowance';
    },
  },
  methods: {
    ...mapActions({
      act_fetchAll: "dashboard/humanResource/fbpDeclarationEss/fetchAll",
      act_fetchAllData:"dashboard/humanResource/fbpDeclarationEss/fetchAllData",
      act_postFBP_declare:"dashboard/humanResource/fbpDeclarationEss/create",
      act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
    }),
    goBack() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/overview/dashboard`
      });
      this.showSuccessMsg = false;
    },
    goSubmit(){
      this.is_submitted = true;
      this.submit()
    },
    backFromPopUp() {
      this.showSuccessMsg = false;
      this.fetchAllData()
      this.fetchAll()
      this.refresh();
    },
    refresh() {
      try {
        this.is_submitted = false;
        this.showErrorMsg = false;
        this.showErrorMsgs = false;
        this.showEmpDetails = false;
        this.fetchingBack = false;
        this.componentList = [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async fetchAll() {
      try {
        let res = await this.act_fetchAll({
          le_id: this.le_id,
          employee_id: this.empId,
        })
        

        this.fbpAllocationDetails = res.data.payload;
        this. formate= new Intl.NumberFormat('en-in',{
        currency: "INR",
        style: "currency"
          });
       this.formateLess= new Intl.NumberFormat('en-in');
        // //console.log(this.fbpAllocationDetails
        // )
        this.is_employee_submitted =res.data.payload.is_employee_submitted
        if (res.data.payload.declaration_details) {
          this.fbpCtcSlabscomponents = [];
          (this.ctcAmount = ""), (this.showJoiningDate = "");
          this.fbpCtcSlabscomponentsandvalue = [];
          this.fbpCtcSlabscomponentsandvalue = res.data.payload.declaration_details;
          this.showJoiningDate = res.data.payload.date_of_joining;
            // const dateString = res.data.payload.date_of_joining;
            // const dateObject = new Date(dateString);
            // const day = dateObject.getDate().toString().padStart(2, '0');
            // const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
            // const year = dateObject.getFullYear();
            // this.showJoiningDate = `${day}/${month}/${year}`;
          this.ctcAmount = res.data.payload.revisionStructure ? res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].ctc : res.data.payload.ctc;
          this.specialAllowance = res.data.payload.FBP
          this.monthltSpecialAllowance = res.data.payload.revisionStructure ? res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].details.find(obj => obj.abbreviation === "SPL-ALW").monthly : res.data.payload.monthlySA;
          this.monthltSpecialAllowanceDeclared = res.data.payload.monthlySAafterFbpDeclared
          this.elementFbpComponentId = res.data.payload.slab_id;
          //console.log(res.data.payload)
          //console.log(this.elementFbpComponentId);
          // this.fetchFBPcomponentlistonly_for_value();
          this.fetchedId = res.data.payload.id;
          this.slabIdFetced = res.data.payload.slab_id;
          this.fetchingBack = true;
          this.gettingNew = false;
          // res.data.payload.declaration_details.forEach((element) => {
          //   this.effectiveDate = element.effective_date
          // })
          if (res.data.payload.revisionStructure) {
            const dateString = res.data.payload.revisionStructure[res.data.payload.revisionStructure.length - 1].from;
            const [year, month, day] = dateString.split("-");
            this.effectiveDate = `${day}/${month}/${year}`;
          }
          else {
            const dateString = res.data.payload.date_of_joining;
            const [day, month, year] = dateString.split("/");
            this.effectiveDate = `${day}/${month}/${year}`;
          }

        } else {
          // this.fetchFBPcomponentlist();
          // //console.log(
          //   "i am inside the else condition",
          //   this.fbpCtcSlabscomponents
          // );
          this.showButtons = true
          this.fbpCtcSlabscomponents = [];
          (this.ctcAmount = ""), (this.showJoiningDate = "");
          res.data.payload.forEach((element) => {
            let eligibilityValue;
            if (element.calculation_type == "FLAT") {
              eligibilityValue = element.monthly_eligibilty;
            } else if (element.calculation_type == "PERCENTAGE_OF_BASIC") {
              eligibilityValue = element.monthly_eligibilty;
            } else {
            }
            (this.ctcAmount = element.ctc),
              (this.showJoiningDate = element.date_of_joining);
            const dateString = element.effective_date;
            const [day, month, year] = dateString.split("/");
            // const dateObject = new Date(dateString);
            // const day = dateObject.getDate().toString().padStart(2, '0');
            // const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
            // const year = dateObject.getFullYear();
            this.effectiveDate = `${day}/${month}/${year}`;

            this.specialAllowance = element.FBP,
            this.monthltSpecialAllowance = element.monthlySA,
            this.monthltSpecialAllowanceDeclared = element.monthlySAafterFbpDeclared
            this.elementFbpComponentId = element.fbp_ctc_slab_id ? element.fbp_ctc_slab_id : element.fbp_level_id ? element.fbp_level_id : element.fbp_location_id ?  element.fbp_location_id : element.fbp_salary_grade_id ;
            this.slabIdFetced = this.elementFbpComponentId
            this.fbpCtcSlabscomponents.push({
              salaryComponentLEName: element.SalaryComponentLegalEntity.name,
              value: Number(Math.round(eligibilityValue)),
              fbp_component_id: element.SalaryComponentLegalEntity.id,
              yearly_eligibility: element.yearly_eligibility,
              remainingMonth: element.remainingMonth,
              remainingDays: element.remainingDays,
              remainingMonth: element.remainingMonth,
              noOfDaysInMonth: element.noOfDaysInMonth,
              monthly_declaration_amount: 0,
              annual_declared_amount: 0,
              code: element.SalaryComponentLegalEntity.code,
              pay_type: element.SalaryComponentLegalEntity.pay_type
            });
          });
          this.gettingNew = true;
          this.fetchingBack = false;
          // for (let salaryId of res.data.payload) {
          //   this.fbpSalaryId =
          //     salaryId.fbp_salary_grade_id ||
          //     salaryId.fbp_level_id ||
          //     salaryId.fbp_location_id ||
          //     salaryId.fbp_ctc_slab_id;
          // }
          this.fbpSalaryId = this.elementFbpComponentId
        }
      } catch (err) {        
        this.config_error = true;
        this.errmsg_popup = err;
      }
    },
    async fetchAllData() {
      try {
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        this.financial_year= response.data.payload[0].payrollDetails.year;
        let res = await this.act_fetchAllData({
          le_id: this.le_id,
          employee_id: this.empId,
          financial_year: this.financial_year,
        })
        if (Array.isArray(res.data.payload.payload)) {
            this.regime_not_selected = res.data.payload.payload[0].regime_type == null?true:false
            this.regimeType = res.data.payload.payload[0].regime_type;
            this.regimeTypeDisplay = this.regimeType == 'newregime'?'New Regime':this.regimeType == 'oldregime'?'Old Regime':'New Regime'
          } else {
            this.regime_not_selected = res.data.payload.payload.regime_type == null?true:false
            this.regimeType = res.data.payload.payload.regime_type;
            this.regimeTypeDisplay = this.regimeType == 'newregime'?'New Regime':this.regimeType == 'oldregime'?'Old Regime':'New Regime'
          }
       if(res.data.payload.payload.declaration_details){
        this.fbpData=[];
        this.fbpData= res.data.payload.payload.declaration_details
        this.fetchedId = res.data.payload.payload.id;
        this.slabIdFetced = res.data.payload.payload.slab_id;
        this.fetchingBack = true;
       }
        else {
          // //console.log(
          //   "i am inside the else condition",
          //   res.data.payload
          // );
          this.fbpData = [];
          this.fetchingBack = false;
          res.data.payload.payload.forEach((element) => {
              this.fbpData.push({
                salaryComponentLEName: element.SalaryComponentLegalEntity.name,
                value: Number(Math.round(element.value)),
                fbp_component_id: element.SalaryComponentLegalEntity.id,
                yearly_eligibility: element.yearly_eligibility,
                annual_declared_amount: element.annual_declared_amount,
                monthly_declaration_amount: element.monthly_declaration_amount,
                remainingMonth: element.remainingMonth,
                remainingDays: element.remainingDays,
                remainingMonth: element.remainingMonth,
                noOfDaysInMonth: element.noOfDaysInMonth,
                effective_date: element.effective_date,
                code:element.SalaryComponentLegalEntity.code
              });
               this.slabIdFetced = element.fbp_ctc_slab_id ? element.fbp_ctc_slab_id : element.fbp_level_id ? element.fbp_level_id : element.fbp_location_id ?  element.fbp_location_id : element.fbp_salary_grade_id ;
          });
        }
        
      } 
      catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },
    saveValues(val, record, key) {
      if(val<0 || val=="-"){
        this.showErrorMsg = false;
        this.showErrorMsgs  = true;
      }
      else if (record.value >= record.monthly_declaration_amount) {
        this.showErrorMsg = false;
        this.showErrorMsgs = false;
        let noOfMonths;
        if (record.remainingDays == 0) {
          noOfMonths = record.remainingMonth;
        } else {
          noOfMonths = record.remainingMonth - 1;
        }
        record[key] = val ? Number(val) : val;
        if(val==""){
          const indexDisplay = this.fbpData.findIndex(
          (i) => i.salaryComponentLEName === record.salaryComponentLEName
        );
        this.fbpData[indexDisplay].annual_declared_amount = 0
        }
        const days = record.noOfDaysInMonth == 0 ? 1 : record.noOfDaysInMonth;
        let annualDeclaredAmount = val
          ? (Number(val) / days) * record.remainingDays +
            (Number(val) * noOfMonths)
          : val;
          record.annual_declared_amount = Number(annualDeclaredAmount.toFixed(2))
        const index = this.fbpData.findIndex(
          (i) => i.salaryComponentLEName === record.salaryComponentLEName
        );
        if (index > -1) {
          this.fbpData[index][key] = val ? Number(val) : val;
          const days = record.noOfDaysInMonth == 0 ? 1 : record.noOfDaysInMonth;
          let annualDeclaredAmount = val
            ? (Number(val) / days) * record.remainingDays +
              Number(val) * noOfMonths
            : val;
            this.fbpData[index].annual_declared_amount = Number(annualDeclaredAmount.toFixed(2));
            // let amount = 0;
            // this.fbpData.map(element => {
            //   amount += Number(element.annual_declared_amount);
            // })
            // console.log(amount,this.fbpData);
            // let lastIndex=lastIndex()
            // this.fbpAllocationDetails.unallocated_amount = this.fbpAllocationDetails.unallocated_amount - amount;
        }
      } else {
        //console.log("i am greater");
        this.showErrorMsg = true;
      }
    },
    saveValuesFecthing(record) {
      let isPresent = this.componentList.some(
        (x) => x.salaryComponentLEName === record.salaryComponentLEName,
      );
      if (isPresent) {
        let index = this.componentList.findIndex(
          (x) => x.salaryComponentLEName === record.salaryComponentLEName
        );
        this.componentList[index].monthly_declaration_amount =
          record.monthly_declaration_amount;
          let annaulValue = record.annual_declared_amount.toFixed(2);
        this.componentList[index].annual_declared_amount = Number(annaulValue)
        
      } else {
        this.componentList.push(record);
      }
      //console.log(this.componentList);
    },
     //submit when save button click
     submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.performingAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },
     saveDraft() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveasdraft();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }
      });
    },

    /* server call to create FBP LOCK */
    async performingAction() {  
      try {
        if (this.fetchingBack) {
          let date = new Date().getFullYear();
          //console.log("res >>>>>>>>>>>>>> ", date);
          let formData = {
            id: this.fetchedId,
            employee_id: this.empId,
            legal_entity_id: this.le_id,
            fbp_year: date,
            slab_id: this.slabIdFetced,
            is_submitted: this.is_submitted,
            declaration_details: this.componentList,
          };
          const res = await this.act_postFBP_declare(formData);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.successMessage =`FBP Declaration has been successfully submitted`;
            this.fetchAllData()
            this.showSuccessMsg = true;
            this.err
          } else {
            this.toast = true;
          }
        } else {
          let date = new Date().getFullYear();
          let formDatas = {
            employee_id: this.empId,
            legal_entity_id: this.le_id,
            fbp_year: date,
            slab_id: this.slabIdFetced,
            is_submitted: this.is_submitted,
            declaration_details: this.componentList,
          };  
                    const res = await this.act_postFBP_declare(formDatas);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.fetchAllData()
            this.showSuccessMsg = true;
            this.successMessage =`FBP Declaration has been successfully submitted`;
          } else {
            this.toast = true;
          }
        }
      } catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },

    async saveasdraft() {  
      try {
        if (this.fetchingBack) {
          let date = new Date().getFullYear();
          //console.log("res >>>>>>>>>>>>>> ", date);
          let formData = {
            id: this.fetchedId,
            employee_id: this.empId,
            legal_entity_id: this.le_id,
            fbp_year: date,
            slab_id: this.slabIdFetced,
            is_submitted: this.is_submitted,
            declaration_details: this.componentList,
          };
          const res = await this.act_postFBP_declare(formData);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.successMessage =`FBP Declaration has been successfully saved`;
            this.showSuccessMsg = true;
            this.err
          } else {
            this.toast = true;
          }
        } else {
          let date = new Date().getFullYear();
          let formDatas = {
            employee_id: this.empId,
            legal_entity_id: this.le_id,
            fbp_year: date,
            slab_id: this.slabIdFetced,
            is_submitted: this.is_submitted,
            declaration_details: this.componentList,
          };  
                    const res = await this.act_postFBP_declare(formDatas);
          if (res.status == 200) {
            this.$root._data.isSaving = false;
            this.showSuccessMsg = true;
            this.successMessage =`FBP Declaration has been successfully saved`;
          } else {
            this.toast = true;
          }
        }
      } catch (error) {
        //console.log(error);
        this.toast = true;
        this.errmsg = error;
      }
    },
  }
};
</script>
<style>
.amountColum {
  background: white;
    padding: 10px;
    margin: 10px 10px 10px 10px;
    flex: 0 0 63%;
    max-width: 31%;
    border-radius: 8px;
    font-size: medium;
    font-weight: 500;

}

.tableList {
  margin-top: 20px;
  margin-left: 20px;
}

.fbp-summary-box {
  background-color: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 1px 2px #f0f0f0;
  margin-left: 15px;
}

.fbp-declaration-text {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #5a5a5a;
  margin-left: 8px;
  font-family: "Montserrat";
}

.amountHeading {
  margin-bottom: 8px;
}

.fbpAmount {
  font-weight: 600;
  color: #5a5a5a;
  font-family: "Montserrat";
}

.custom {
  width: 180px;
}
.alert-msg{
  margin-left: 1rem;
}
.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 1rem3;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  border-color: #f5c2c7;
}
.tableClass{
  text-transform: capitalize;
}
.submitNote{
  display: flex;
  flex-direction: row;
  color: red;
  font-size: 1rem;
  font-weight: 400;
    .note{
       padding-bottom: 10px;
       padding-left: 8px;
    }
    .noteContent{
      padding-left: 8px;
      display: flex;
      flex-direction: column;
    }
}
.regime-Type{
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  width: 100%;
  padding-right: 60px;
}
</style>
